import { useState, useEffect } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';

export const NavBar = () => {
    const [activeLink,  setActiveLink] = useState('home');
    const [scrolled, seScrolled] = useState(false);

    useEffect (() => {
        const onScroll = () => {
            if(window.scrollY > 50) {
                seScrolled(true)
            } else {
                seScrolled(false)
            }
        }

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const onUpdateActiveLink = (value) => { setActiveLink(value) }

    return (
        <Navbar expand="lg" collapseOnSelect className={scrolled ? 'scrolled' : ''}>
        <Container>
            <Navbar.Toggle aria-controls="basic-navbar-nav">
                <span className='navbar-toggler-icon'></span>
            </Navbar.Toggle>
            <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
                <Nav.Link href="#home" className={activeLink === 'home' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('home')}>Home</Nav.Link>
                <Nav.Link href="#projects" className={activeLink === 'projects' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('projects')}>Projects</Nav.Link>
                <Nav.Link href="#my-stack" className={activeLink === 'my-stack' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('my-stack')}>Skills</Nav.Link>
                <Nav.Link href="#connect" className={activeLink === 'contact' ? 'active navbar-link' : 'navbar-link'} onClick={() => onUpdateActiveLink('contact')}>Contact</Nav.Link>
            </Nav>
            
            </Navbar.Collapse>
        </Container>
        </Navbar>
    );
}